var React = require('react');

function Mtn (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"120","height":"60","rx":"8","fill":"#FFCC00","key":0}),React.createElement("ellipse",{"cx":"60","cy":"30","rx":"50","ry":"22","fill":"none","stroke":"#000","strokeWidth":"4","key":1}),React.createElement("path",{"fill":"#000","d":"M26 40V20h6l5 10 5-10h6v20h-5V29l-5 9h-2l-5-9v11zM51 20h18v5h-6.5v15h-5V25H51zM72 40V20h5l10 12V20h5v20h-5L77 28v12z","key":2})]);
}

Mtn.defaultProps = {"viewBox":"0 0 120 60"};

module.exports = Mtn;

Mtn.default = Mtn;
